import ViewDMALicenses from './ViewDMALicenses'
export default ViewDMALicenses
